($ => {

    "use strict";

    const filterNames = ["termo", "tema", "tipoTrabalho", "faixaPreco", "estado", "idioma", "genero", "incluirCurriculo"];
    const fixedToolbarClass = "catalog-toolbar-is-fixed";
    const fetchHeaders = { "X-Requested-With": "XMLHttpRequest" };
    let listenersBound = false;
    let cardsPrefetch = { key: "", html: "", promise: null };
    let resultsRequest = null;
    let restoreSnapTimer;
    let previousSnap;

    function revealResults({ focus = true } = {}) {
        const target = document.getElementById("catalog-results");
        if (!target) return;
        syncCatalogToolbarFixed();
        const html = document.documentElement;
        if (!restoreSnapTimer) previousSnap = html.style.scrollSnapType;
        window.clearTimeout(restoreSnapTimer);
        html.style.scrollSnapType = "none";
        if (focus) {
            target.setAttribute("tabindex", "-1");
            target.focus({ preventScroll: true });
        }
        target.scrollIntoView({
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth",
            block: "start",
        });
        restoreSnapTimer = window.setTimeout(() => {
            html.style.scrollSnapType = previousSnap;
            restoreSnapTimer = null;
        }, 900);
    }

    function revealInitialResults() {
        const requestedSearch = window.location.search;
        window.setTimeout(() => {
            if (!isCatalogPage() || window.location.search !== requestedSearch) return;
            revealResults({ focus: false });
        }, 120);
    }

    function catalogForm() {
        return document.getElementById("catalog-search-form");
    }

    function isCatalogPage() {
        return Boolean(document.querySelector(".page-palestrantes-catalog"));
    }

    function paramsFromForm() {
        const params = new URLSearchParams();
        const form = catalogForm();
        if (!form) {
            return params;
        }
        new FormData(form).forEach((value, key) => {
            const next = String(value).trim();
            if (next !== "") {
                params.set(key, next);
            }
        });
        return params;
    }

    function catalogUrl(params, fragment) {
        const form = catalogForm();
        const url = new URL(form?.action || window.location.href, window.location.origin);
        url.search = "";
        params.forEach((value, key) => {
            if (key !== "fragment" && key !== "pagina" && String(value).trim() !== "") {
                url.searchParams.set(key, value);
            }
        });
        if (fragment) {
            url.searchParams.set("fragment", fragment);
        }
        return url;
    }

    function catalogGrid() {
        return document.querySelector("#catalog-results .catalog-grid");
    }

    function catalogLoadMoreButton() {
        return document.querySelector("#catalog-results [data-catalog-load-more]");
    }

    function nextCatalogPage() {
        const button = catalogLoadMoreButton();
        const page = Number(button?.dataset.page || 0);
        return button && page ? page + 1 : 0;
    }

    function cardsUrl(page) {
        const url = catalogUrl(paramsFromForm(), "cards");
        url.searchParams.set("pagina", String(page));
        return url;
    }

    function resetCardsPrefetch() {
        cardsPrefetch = { key: "", html: "", promise: null };
    }

    function prefetchCards(page) {
        if (!isCatalogPage() || !page) {
            return;
        }
        const key = cardsUrl(page).toString();
        if (cardsPrefetch.key === key && (cardsPrefetch.html || cardsPrefetch.promise)) {
            return;
        }
        const request = fetch(key, { headers: fetchHeaders })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("catalog-prefetch-failed");
                }
                return response.text();
            })
            .then((text) => {
                const html = text.trim();
                if (cardsPrefetch.key === key) {
                    cardsPrefetch.html = html;
                    cardsPrefetch.promise = null;
                }
                return html;
            })
            .catch(() => {
                if (cardsPrefetch.key === key) {
                    resetCardsPrefetch();
                }
                return "";
            });
        cardsPrefetch = { key, html: "", promise: request };
    }

    let prefetchObserver = null;

    /**
     * A próxima página de cards só é pedida quando o botão "Carregar mais" chega perto da tela (antes era logo após o
     * load, renderizando no servidor uma página que a maioria dos visitantes nunca chega a ver).
     */
    function scheduleCardsPrefetch(page) {
        const run = () => prefetchCards(page);
        prefetchObserver?.disconnect();
        prefetchObserver = null;
        const button = catalogLoadMoreButton();
        if (button && "IntersectionObserver" in window) {
            prefetchObserver = new IntersectionObserver((entries) => {
                if (entries.some((entry) => entry.isIntersecting)) {
                    prefetchObserver?.disconnect();
                    prefetchObserver = null;
                    run();
                }
            }, { rootMargin: "900px 0px" });
            prefetchObserver.observe(button);
            return;
        }
        if ("requestIdleCallback" in window) {
            window.requestIdleCallback(run, { timeout: 800 });
            return;
        }
        window.setTimeout(run, 120);
    }

    async function fetchCardsHtml(page) {
        const key = cardsUrl(page).toString();
        if (cardsPrefetch.key === key) {
            if (cardsPrefetch.html) {
                const html = cardsPrefetch.html;
                resetCardsPrefetch();
                return html;
            }
            if (cardsPrefetch.promise) {
                const html = await cardsPrefetch.promise;
                resetCardsPrefetch();
                if (!html) {
                    throw new Error("catalog-load-failed");
                }
                return html;
            }
        }
        const response = await fetch(key, { headers: fetchHeaders });
        if (!response.ok) {
            throw new Error("catalog-load-failed");
        }
        return (await response.text()).trim();
    }

    function appendCatalogCards(html) {
        const grid = catalogGrid();
        const template = document.createElement("template");
        template.innerHTML = html;
        const cards = [...template.content.querySelectorAll(".card-palestrante-site")];
        if (!grid || !cards.length) {
            throw new Error("catalog-load-empty");
        }
        cards.forEach((card) => grid.appendChild(card));
        document.dispatchEvent(new CustomEvent("site:cesta-sync"));

        const meta = template.content.querySelector("[data-catalog-append], [data-catalog-load-more], [data-cesta-pick-load-more]");
        const loadedPage = Number(meta?.getAttribute("data-page") || 0);
        const hasMore = meta?.getAttribute("data-has-more") === "1"
            || Boolean(template.content.querySelector("[data-catalog-load-more], [data-cesta-pick-load-more]"));
        return { loadedPage, hasMore };
    }

    function setSelectValue(name, value) {
        const form = catalogForm();
        if (!form) {
            return;
        }
        const native = form.querySelector(`[name="${name}"]`);
        if (!native) {
            return;
        }
        native.value = value;
        const root = native.closest("[data-site-select]");
        if (!root) {
            return;
        }
        const option = [...root.querySelectorAll("[role='option']")]
            .find((item) => (item.getAttribute("data-value") ?? "") === String(value));
        const valueNode = root.querySelector(".site-select-value");
        if (valueNode) {
            valueNode.textContent = option?.textContent?.trim()
                || native.options[native.selectedIndex]?.text
                || "";
        }
        root.querySelectorAll("[role='option']").forEach((item) => {
            item.classList.toggle("is-selected", item === option);
        });
    }

    function syncFormFromParams(params) {
        const form = catalogForm();
        if (!form) {
            return;
        }
        filterNames.forEach((name) => {
            const value = params.get(name) || "";
            const field = form.querySelector(`[name="${name}"]`);
            if (!field) {
                return;
            }
            if (field.tagName === "SELECT") {
                setSelectValue(name, value);
                return;
            }
            field.value = value;
        });
        const curriculo = document.querySelector('#site-filter-palestrantes-form [name="incluirCurriculo"]');
        if (curriculo) curriculo.checked = params.get("incluirCurriculo") === "1";
    }

    async function loadResults(params, { push = true, reveal = true } = {}) {
        const box = document.getElementById("catalog-results");
        const form = catalogForm();
        const nextLocation = catalogUrl(params);
        if (!box || !form) {
            window.location.assign(nextLocation.toString());
            return;
        }

        resultsRequest?.abort();
        const request = new AbortController();
        resultsRequest = request;
        box.setAttribute("aria-busy", "true");
        const loading = document.createElement("p");
        loading.className = "catalog-search-loading";
        loading.setAttribute("role", "status");
        loading.textContent = box.dataset.loadingText || "Carregando palestrantes…";
        box.prepend(loading);
        revealResults({ focus: false });
        try {
            const response = await fetch(catalogUrl(params, "results").toString(), {
                headers: fetchHeaders,
                signal: request.signal,
            });
            if (!response.ok) {
                throw new Error("catalog-filter-failed");
            }

            const template = document.createElement("template");
            template.innerHTML = (await response.text()).trim();
            const next = template.content.querySelector("#catalog-results");
            if (request.signal.aborted || !box.isConnected) return;
            if (!next) {
                throw new Error("catalog-filter-empty");
            }

            resetCardsPrefetch();
            box.replaceWith(next);
            document.dispatchEvent(new CustomEvent("site:cesta-sync"));
            if (push) {
                history.pushState({ catalog: true }, "", nextLocation.pathname + nextLocation.search);
            }
            syncFormFromParams(params);
            scheduleCardsPrefetch(nextCatalogPage());
            if (reveal) revealResults();
        } catch (_error) {
            if (request.signal.aborted || !box.isConnected) return;
            nextLocation.hash = "catalog-results";
            window.location.assign(nextLocation.toString());
        } finally {
            loading.remove();
            if (resultsRequest === request) {
                resultsRequest = null;
                box.removeAttribute("aria-busy");
            }
        }
    }

    function syncCatalogScroller(track) {
        const scroller = track.querySelector("[data-catalog-scroller]");
        if (!scroller) {
            return;
        }
        const max = scroller.scrollWidth - scroller.clientWidth;
        const overflowing = max > 8;
        track.classList.toggle("is-overflowing", overflowing);
        track.querySelectorAll("[data-catalog-scroll]").forEach((button) => {
            const delta = Number(button.getAttribute("data-catalog-scroll"));
            button.disabled = !overflowing || (delta < 0 ? scroller.scrollLeft <= 8 : scroller.scrollLeft >= max - 8);
        });
    }

    function bindCatalogChrome() {
        document.querySelectorAll(".catalog-destaques-track").forEach((track) => {
            if (track.dataset.bound === "true") {
                return;
            }
            track.dataset.bound = "true";
            const scroller = track.querySelector("[data-catalog-scroller]");
            syncCatalogScroller(track);
            scroller?.addEventListener("scroll", () => syncCatalogScroller(track), { passive: true });
            $(track).on("click", "[data-catalog-scroll]", function () {
                const delta = Number(this.getAttribute("data-catalog-scroll"));
                scroller?.scrollBy({ left: delta * Math.max(180, scroller.clientWidth * 0.6), behavior: "smooth" });
            });
        });
    }

    function syncCatalogToolbarFixed() {
        const shell = document.querySelector(".catalog-toolbar-shell");
        const row = shell?.querySelector(".catalog-toolbar-row");
        if (!isCatalogPage() || !shell || !row) {
            document.body.classList.remove(fixedToolbarClass);
            document.documentElement.style.removeProperty("--catalog-toolbar-offset");
            document.querySelectorAll(".catalog-toolbar-shell.is-fixed").forEach((item) => {
                item.classList.remove("is-fixed");
            });
            return;
        }

        const header = document.getElementById("site-header");
        const headerHeight = header?.offsetHeight
            || parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--site-header-height"))
            || 72;
        const shellTop = shell.getBoundingClientRect().top + window.scrollY;
        const shouldFix = window.scrollY >= Math.max(0, shellTop - headerHeight);
        const toolbar = row.querySelector(".catalog-toolbar") || row;
        document.documentElement.style.setProperty("--catalog-toolbar-offset", `${toolbar.offsetHeight}px`);

        if (!shouldFix) {
            shell.classList.remove("is-fixed");
            document.body.classList.remove(fixedToolbarClass);
            shell.style.removeProperty("--catalog-toolbar-height");
            return;
        }

        if (!shell.classList.contains("is-fixed")) {
            shell.style.setProperty("--catalog-toolbar-height", `${row.offsetHeight}px`);
            shell.classList.add("is-fixed");
        }

        document.body.classList.add(fixedToolbarClass);
    }

    function bindListeners() {
        if (listenersBound) {
            return;
        }
        listenersBound = true;

        $(window).on("resize", function () {
            $(".catalog-destaques-track").each(function () {
                syncCatalogScroller(this);
            });
            syncCatalogToolbarFixed();
        });

        $(document).on("click", ".catalog-scroll-hint[href='#catalog-results']", function (event) {
            const target = document.getElementById("catalog-results");
            if (!target) {
                return;
            }
            event.preventDefault();
            revealResults();
            history.replaceState(null, "", `${window.location.pathname}${window.location.search}#catalog-results`);
        });

        $(document).on("change", "#catalog-search-form select", function () {
            loadResults(paramsFromForm());
        });

        $(document).on("click", "[data-catalog-filter]", function (event) {
            const name = this.getAttribute("data-catalog-filter");
            if (!name || !catalogForm()) {
                return;
            }
            event.preventDefault();
            setSelectValue(name, this.getAttribute("data-value") || "");
            loadResults(paramsFromForm());
        });

        $(document).on("click", ".catalog-filter-clear, #catalog-results .applied-filters-container a", function (event) {
            const href = this.getAttribute("href");
            if (!href || !catalogForm()) {
                return;
            }
            const url = new URL(href, window.location.origin);
            if (!url.pathname.includes("/palestrantes") || url.pathname.includes("/tema/")) {
                return;
            }
            event.preventDefault();
            const params = url.searchParams;
            syncFormFromParams(params);
            loadResults(params);
        });

        $(document).on("click", "[data-catalog-load-more]", async function () {
            const loadMore = this;
            if (loadMore.disabled || loadMore.getAttribute("aria-busy") === "true") {
                return;
            }
            const grid = catalogGrid();
            const nextPage = Number(loadMore.dataset.page) + 1;
            if (!grid || !nextPage) {
                return;
            }

            const label = loadMore.textContent;
            loadMore.disabled = true;
            loadMore.setAttribute("aria-busy", "true");
            loadMore.textContent = loadMore.dataset.loadingText || label;

            try {
                const requestKey = cardsUrl(nextPage).toString();
                const html = await fetchCardsHtml(nextPage);
                if (!document.body.contains(loadMore) || cardsUrl(nextPage).toString() !== requestKey) {
                    return;
                }
                const { loadedPage, hasMore } = appendCatalogCards(html);
                const currentPage = loadedPage || nextPage;
                loadMore.dataset.page = String(currentPage);
                if (!hasMore) {
                    loadMore.closest(".catalog-load-more")?.remove();
                    resetCardsPrefetch();
                    return;
                }
                loadMore.disabled = false;
                loadMore.removeAttribute("aria-busy");
                loadMore.textContent = label;
                scheduleCardsPrefetch(currentPage + 1);
            } catch (_error) {
                loadMore.disabled = false;
                loadMore.removeAttribute("aria-busy");
                loadMore.textContent = label;
            }
        });

        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        const syncToTop = () => {
            const toTop = document.querySelector("[data-site-to-top]");
            if (toTop) {
                toTop.hidden = window.scrollY < 420;
            }
            syncCatalogToolbarFixed();
        };
        window.addEventListener("scroll", syncToTop, { passive: true });
        $(document).on("click", "[data-site-to-top]", function () {
            window.scrollTo({ top: 0, behavior: reducedMotion ? "auto" : "smooth" });
        });

        window.addEventListener("popstate", () => {
            if (!isCatalogPage()) {
                return;
            }
            const params = new URLSearchParams(window.location.search);
            syncFormFromParams(params);
            loadResults(params, { push: false, reveal: false });
        });
    }

    function boot() {
        bindListeners();
        if (!isCatalogPage()) {
            syncCatalogToolbarFixed();
            return;
        }
        bindCatalogChrome();
        const form = catalogForm();
        if (form && form.dataset.catalogSearchBound !== "true") {
            form.dataset.catalogSearchBound = "true";
            form.addEventListener("submit", (event) => {
                event.preventDefault();
                // The shared form handler calls native submit(); this search owns its request.
                event.stopPropagation();
                loadResults(paramsFromForm());
            });
        }
        syncCatalogToolbarFixed();
        scheduleCardsPrefetch(nextCatalogPage());
        const params = new URLSearchParams(window.location.search);
        if (filterNames.some((name) => params.get(name)?.trim()) || window.location.hash === "#catalog-results") {
            revealInitialResults();
        }
        const toTop = document.querySelector("[data-site-to-top]");
        if (toTop) {
            toTop.hidden = window.scrollY < 420;
        }
    }

    window.siteReady(boot);

})(jQuery);
